// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"536f58f5","878":"a73c937a","891":"a85fe45e"}[chunkId] + ".chunk.js";
};